<script setup lang="ts">
    import './index.scss';

    const props = defineProps({
        modelValue: {
            type: Array<any>,
            defaultValue: '',
            required: true
        },
        disableClick: {
            type: Boolean,
            defaultValue: false,
            required: false
        },
        class: {
            type: String,
            required: false
        },
    })

    const steps = ref(props.modelValue)

    // For settings the class depending on the prop.
    const classObject = computed(() => ({
        // 'border-none' : props.borderless == true,
    }))

    const setClickCurrent = (setIndex: number) => {
        handleSetCurrent(setIndex);
    }

    const setCurrent = (currentIndex: number) => {
        steps.value = steps.value.map((u: any) => {
            if(u.key === currentIndex || u.key < currentIndex) {
                return {
                    ...u,
                    status: 1
                }
            }
            else {
                return {
                    ...u,
                    status: 0
                }
            }
        })
    };

    defineExpose({
        setCurrent,
    });

    const emit = defineEmits<{
        (e: 'setCurrentEvent', setIndex: number): void
    }>()

    const handleSetCurrent = (setIndex: number) => {
        emit('setCurrentEvent', setIndex);
    }

</script>

<template>
    <Block
        :class="[
            'flex justify-between max-md:gap-[1.6rem]',
            props.class
        ]"
    >
        <template v-for="item in steps" :key="item.title">
            <Block class="flex flex-col items-center justify-center cursor-pointer max-md:justify-start">
                <Block
                    @click="!props.disableClick ? setClickCurrent(item.key) : null"
                    :class="[
                        { 'text-[goldenYellow] border border-[goldenYellow]' : item.status == 0 },
                        { 'bg-[goldenYellow] text-[white] ' : item.status == 1 },
                        'w-[3.2rem] h-[3.2rem] flex items-center justify-center rounded-full max-md:w-[1.6rem] max-md:h-[1.6rem] max-md:text-[1.2rem]'
                    ]"
                >
                    {{ item.key }}
                </Block>
                <Block 
                    :class="[
                        { 'text-[titleColor]' : item.status == 0 },
                        { 'text-[goldenYellow]' : item.status == 1 },
                        'mt-[1rem] text-[1.6rem] leading-[1.5] text-center max-md:text-[1.2rem]'
                    ]">
                    {{ item.title }}
                </Block>
            </Block>
        </template>
    </Block>
</template>

